import useActionEffect from 'core/redux/hooks/useActionEffect';
import fetchInstance from 'app/games/hangedman/actions/fetchInstance';

export default function useFetchInstance(id) {
  return useActionEffect(fetchInstance, id);
}
